import { createSlice } from '@reduxjs/toolkit';
import axios from "../axios-pogo";
import {showError} from "./coreSlice";
import cookie from "react-cookies";

const defenderSlice = createSlice({
	name: 'defender',
	initialState: {
		showDefenders: false,
		defenders: [],
	},
	reducers: {
		setShowDefenders(state, action) { state.showDefenders = action.payload;	},
		setDefenders(state, action) {
			state.defenders = action.payload;
		},
	}
});

export const { setDefenders, setShowDefenders }
	= defenderSlice.actions;

export default defenderSlice.reducer;

export const saveDefenders = (gymIds) => {
	return (dispatch, getState) => {
		dispatch(setDefenders(gymIds)); // optimistic

		axios.post("/mod/pokemon/map/ajax/save-defenders.php", {
			gyms: gymIds.join(','),
			discord: cookie.load('discord')
		}).then(result => {
			console.log("Defenders saved.", gymIds);
		}).catch(error => {
			console.log("Error saving defenders: ", error);
			dispatch(showError("Error saving defenders. Please refresh page."));
		});
	}
};